

// DEPENDENCIES
import axios from 'axios';

// INNER IMPORTS
import { connection } from '../Config/Settings';
import {savePin, deleteWaitingLogin } from './users';

import { isMobile } from "../utils";
import {contactMessageWasSent} from "../Models/strings";
import {generalErrorMsg} from "../Models/errors";
import {LIVE_MUSIC} from "../consts";

// this event being shot by the router
export const LOCATION_CHANGE                    = '@@router/LOCATION_CHANGE';

export const SEND_CONTACT_EMAIL                 = 'SEND_CONTACT_EMAIL';
export const SEND_CONTACT_SUCCESS               = 'SEND_CONTACT_SUCCESS';
export const SEND_CONTACT_FAILURE               = 'SEND_CONTACT_FAILURE';

export const OPEN_CONTACT_MODAL                 = 'OPEN_CONTACT_MODAL';
export const CLOSE_CONTACT_MODAL                = 'CLOSE_CONTACT_MODAL';

export const OPEN_PAYING_METHODS_MODAL          = 'OPEN_PAYING_METHODS_MODAL';
export const CLOSE_PAYING_METHODS_MODAL         = 'CLOSE_PAYING_METHODS_MODAL';

export const SEND_PAYING_REQ                    = 'SEND_PAYING_REQ';
export const SEND_PAYING_SUCCESS                = 'SEND_PAYING_SUCCESS';
export const SEND_PAYING_FAILURE                = 'SEND_PAYING_FAILURE';

export const OPEN_CATEGORIES_MODAL              = 'OPEN_CATEGORIES_MODAL';
export const CLOSE_CATEGORIES_MODAL             = 'CLOSE_CATEGORIES_MODAL';

export const OPEN_GENERAL_MESSAGE_MODAL         = 'OPEN_GENERAL_MESSAGE_MODAL';
export const CLOSE_GENERAL_MESSAGE_MODAL        = 'CLOSE_GENERAL_MESSAGE_MODAL';

export const OPEN_VIDEO_MODAL                   = 'OPEN_VIDEO_MODAL';
export const CLOSE_VIDEO_MODAL                  = 'CLOSE_VIDEO_MODAL';

export const OPEN_NAV_MODAL                     = 'OPEN_NAV_MODAL';
export const CLOSE_NAV_MODAL                    = 'CLOSE_NAV_MODAL';

export const OPEN_LOADING_SPINNER               = 'OPEN_LOADING_SPINNER';
export const CLOSE_LOADING_SPINNER              = 'CLOSE_LOADING_SPINNER';

export const OPEN_SPLASH_SCREEN_MODAL           = 'OPEN_SPLASH_SCREEN_MODAL';
export const CLOSE_SPLASH_SCREEN_MODAL          = 'CLOSE_SPLASH_SCREEN_MODAL';

export const OPEN_BAND_FINDER_PIN_MODAL         = 'OPEN_BAND_FINDER_PIN_MODAL';
export const CLOSE_BAND_FINDER_PIN_MODAL        = 'CLOSE_BAND_FINDER_PIN_MODAL';

export const GET_SHARE_PIN_SUCCESS              = 'GET_SHARE_PIN_SUCCESS';
export const GET_SHARE_PIN_FAILURE              = 'GET_SHARE_PIN_FAILURE';

export const GET_MAP_PINS_REQUEST               = 'GET_MAP_PINS_REQUEST';
export const GET_MAP_PINS_SUCCESS               = 'GET_MAP_PINS_SUCCESS';
export const GET_MAP_PINS_FAILURE               = 'GET_MAP_PINS_FAILURE';

export const CLEAR_NEW_PIN_LIST                 = 'CLEAR_NEW_PIN_LIST';

export const TOGGLE_MAP_TOP                     = 'TOGGLE_MAP_TOP';
export const TOGGLE_IS_SEARCH_LOCATION_MODE     = 'TOGGLE_IS_SEARCH_LOCATION_MODE';

export const SET_CHOSEN_DATE_LABEL              = 'SET_CHOSEN_DATE_LABEL';
export const SET_COUNTRY_PIN_COUNT              = 'SET_COUNTRY_PIN_COUNT';
export const CLEAR_COUNTRY_PIN_COUNT            = 'CLEAR_COUNTRY_PIN_COUNT';

export const CLEAR_PINS_LIST                    = 'CLEAR_PINS_LIST';

export const INC_PIN_VIEW_COUNT_REQUEST         = 'INC_PIN_VIEW_COUNT_REQUEST'
export const INC_PIN_VIEW_COUNT_SUCCESS         = 'INC_PIN_VIEW_COUNT_SUCCESS'
export const INC_PIN_VIEW_COUNT_FAILURE         = 'INC_PIN_VIEW_COUNT_FAILURE'

export const TOGGLE_MOBILE_FILTER_BAR           = 'TOGGLE_MOBILE_FILTER_BAR'


export function getMapPinsRequest() {
    return {
        type: GET_MAP_PINS_REQUEST
    }
}

export function getMapPinsSuccess(mapPins) {
    return {
        type: GET_MAP_PINS_SUCCESS,
        mapPins
    }
}

export function getMapPinsFailure(err) {
    return {
        type: GET_MAP_PINS_FAILURE,
        err
    }
}

export function getPinsRequest() {
    return {
        type: 'GET_PINS_REQUEST'
    }
}

export function getPinsSuccess({ pins, pages, pinsCount }) {
    return {
        type: 'GET_PINS_SUCCESS',
        pins,
        pages,
        pinsCount
    }
}

export function getPinsFailure(err) {
    return {
        type: 'GET_PINS_FAILURE',
        error: err
    }
}

export const addFilter = (filter, value) => ({
    type: 'ADD_FILTER',
    filter,
    value
})

export const updateFilters = ({ type, category, subCategory, pageNumber }) => ({
    type: 'UPDATE_FILTERS',
    payload: { type, category, subCategory, pageNumber }
})

export const resetFiltersType = type => ({
    type: 'RESET_FILTERS_TYPE',
    payload: { type }
})

export function removeFilter(filter) {
    return (dispatch) => {
        dispatch({
            type: 'REMOVE_FILTER',
            filter: filter
        });
        return Promise.resolve();
    }
}

export function changeLocationOnMap(lat, lng) {
    return {
        type: 'CHANGE_LOCATION_ON_MAP',
        lat: lat,
        lng: lng
    }
}

export function openPinModal(data) {
    return {
        type: 'OPEN_PIN_MODAL',
        data: data
    }
}

export function openBandFinderPinModal(data) {
    return {
        type: OPEN_BAND_FINDER_PIN_MODAL,
        data: data
    }
}

export function closePinModal() {
    return {
        type: 'CLOSE_PIN_MODAL'
    }
}

export function closeBandFinderPinModal() {
    return {
        type: CLOSE_BAND_FINDER_PIN_MODAL
    }
}

export function toggleMode() {
    return {
        type: 'TOGGLE_MODE'
    }
}

export function getDatatypesRequest() {
    return {
        type: 'GET_DATATYPES_REQUEST'
    }
}

export function getDatatypesSuccess(response) {
    return {
        type: 'GET_DATATYPES_SUCCESS',
        datatypes: response.data
    }
}

export function getDatatypesFailure(err) {
    return {
        type: 'GET_DATATYPES_FAILURE',
        error: err
    }
}

// this is in ES6, this all file should be refactored, for now only new code will be ES6
// also from here line starts code with type variables (not going to refactor the whole project at this point)
export const openContactModal = () => ({
    type: OPEN_CONTACT_MODAL
});

export const closeContactModal = () => ({
    type: CLOSE_CONTACT_MODAL
});

export const sendContact = () => ({
    type: SEND_CONTACT_EMAIL
});

export const sendContactSuccess = () => ({
    type: SEND_CONTACT_SUCCESS
});

export const sendContactFailure = () => ({
    type: SEND_CONTACT_FAILURE
});

export const openPayingMethodsModal = () => ({
    type: OPEN_PAYING_METHODS_MODAL,
});

export const closePayingMethodsModal = () => ({
    type: CLOSE_PAYING_METHODS_MODAL
});

export const sendPayingReq = (enrolType) => ({
    type: SEND_PAYING_REQ,
    enrolType

});

export const sendPayingSuccess = (res) => ({
    type: SEND_PAYING_SUCCESS,
    response: res
});

export const sendPayingFailure = (err) => ({
    type: SEND_PAYING_FAILURE,
    error: err
});

export const openCategoriesModal = (catType, category) => ({
    type: OPEN_CATEGORIES_MODAL,
    catType,
    category
});

export const closeCategoriesModal = () => ({
    type: CLOSE_CATEGORIES_MODAL
});

export const openGeneralMessageModal = (header, message, list, confirm) => ({
    type: OPEN_GENERAL_MESSAGE_MODAL,
    header,
    message,
    list,
    confirm
});

export const openConfirmMessageModal = ({ header, message, confirm, isCancel }) => ({
    type: OPEN_GENERAL_MESSAGE_MODAL,
    header,
    message,
    confirm,
    isCancel
});

export const closeGeneralMessageModal = () => ({
    type: CLOSE_GENERAL_MESSAGE_MODAL
});

export const openVideoModal = () => ({
    type: OPEN_VIDEO_MODAL,
});

export const closeVideoModal = () => ({
    type: CLOSE_VIDEO_MODAL
});

export const openNavModal = () => ({
    type: OPEN_NAV_MODAL,
});

export const closeNavModal = () => ({
    type: CLOSE_NAV_MODAL
});

export const openLoadingModal = () => ({
    type: OPEN_LOADING_SPINNER,
});

export const closeLoadingModal = () => ({
    type: CLOSE_LOADING_SPINNER
});

export const openSplashScreenModal = () => ({
    type: OPEN_SPLASH_SCREEN_MODAL,
});

export const closeSplashScreenModal = () => ({
    type: CLOSE_SPLASH_SCREEN_MODAL
});

export const getSharedPinSuccess = (response) => ({
    type: GET_SHARE_PIN_SUCCESS,
    response
});

export const getSharedPinFailure = (error) => ({
    type: GET_SHARE_PIN_FAILURE,
    error
});

export const clearPinList = () => ({
    type: CLEAR_NEW_PIN_LIST
});

export const toggleMapTop = () => ({
    type: TOGGLE_MAP_TOP
})

export const toggleSearchLocationMode = () => ({
    type: TOGGLE_IS_SEARCH_LOCATION_MODE
})

export const setChosenDateLabel = chosenDateLabel => ({
    type: SET_CHOSEN_DATE_LABEL,
    chosenDateLabel
});

export const setCountryPinCount = ({ pinCount, country }) => ({
    type: SET_COUNTRY_PIN_COUNT,
    pinCount,
    country
})

export const clearCountryPinCount = () => ({
    type: CLEAR_COUNTRY_PIN_COUNT
})

export const clearPinsList = () => ({
    type: CLEAR_PINS_LIST
})

export const incPinViewCountRequest = () => ({
    type: INC_PIN_VIEW_COUNT_REQUEST,
})

export const incPinViewCountSuccess = pinId => ({
    type: INC_PIN_VIEW_COUNT_SUCCESS,
    pinId
})

export const incPinViewCountFailure = () => ({
    type: INC_PIN_VIEW_COUNT_FAILURE,
})

export const toggleMobileFilterBar = () => ({
    type: TOGGLE_MOBILE_FILTER_BAR
})

//////////////////////////////// Sync Thunk requests /////////////
export function getDatatypes() {
    return (dispatch) => {
        dispatch(getDatatypesRequest());
        axios.post(connection().serverUrl + "/api/datatypes").then((res) => {
            dispatch(getDatatypesSuccess(res));
        }).catch((err)=> {
            dispatch(getDatatypesFailure(err))
        })
    }
}

export function getPinCountCall() {
    return (dispatch, getState) => {

        const state = getState() || {};
        const { filters } = state.main || {};

        const {location, type, begins, ends } = filters;

        let countryPinCount = 'Israel';
        if (location && location.country) countryPinCount = location.country;

        axios.post(`${connection().serverUrl}/api/pin-count`, { type, countryPinCount, begins, ends })
            .then(res => {
                if (!res || res.status !== 200 || !res.data) throw new Error(`Failed getting country pin count`);

                if (!res.data.pinCount && res.data.pinCount !== 0) return;

                dispatch(setCountryPinCount({ pinCount: res.data.pinCount, country: countryPinCount }));
            })
            .catch(err => {
                console.log('Failed getting country pin count')
            })
    }
}

export function getPinsCall(filters) {
    return (dispatch, getState) => {
        dispatch(getPinsRequest());
        // Fetching all pins according to filters specified
        if (!filters) filters = {};

        // count current pins type
        let currentPins = [...getState().main.pinsNew];
        if (filters.pageNumber === 0 && currentPins.length > 0) return;
        if (filters.type === LIVE_MUSIC && (!filters.begins || !filters.ends)) return;

        const pinTypeCount = {
            huge: 0,
            high: 0,
            mid: 0,
            free: 0
        };

        currentPins.forEach(p => {
            const { enrolType, upgrade} = p.subscription;

            if ((!upgrade && enrolType === 'huge' ) || upgrade === 'huge') return pinTypeCount.huge++;
            if ((!upgrade && enrolType === 'high' ) || upgrade === 'high') return pinTypeCount.high++;
            if ((!upgrade && enrolType === 'mid' ) || upgrade === 'mid') return pinTypeCount.mid++;
            if ((!upgrade && enrolType === 'free' ) || upgrade === 'free') return pinTypeCount.free++;
        });

        const pastScroll = window.pageYOffset;

        axios.post(`${connection().serverUrl}/api/pins/${filters.pageNumber || 0}`, { ...filters, pinTypeCount, isMobile: isMobile() })
            .then((res) => {

                // currentPins = [...getState().main.pinsNew];
                // make sure no duplications
                if (currentPins && currentPins[0] && res.data.pins && res.data.pins[0]) {

                    const newPinsLength = res.data.pins.length;

                    for (let i = 0; i < newPinsLength; i++) {
                        if (currentPins[0]._id === res.data.pins[i]._id) return;
                    }
                }

                const pins = [...currentPins, ...res.data.pins] // filters.pageNumber > 0 ? [...currentPins, ...res.data.pins] : res.data.pins;

                dispatch(getPinsSuccess({ pins, pages: res.data.pages }));

                if (!isMobile()) window.scrollTo(0, pastScroll);

                closeLoadingModal();
            }).catch((err) => {
            dispatch(getPinsFailure(err));
        })
    }
}

export function getMapPinsCall(filters) {
    return dispatch => {

        if (!filters) filters = {};
        if (filters.type === LIVE_MUSIC && (!filters.begins || !filters.ends)) return;

        dispatch(getMapPinsRequest());
        return axios.post(`${connection().serverUrl}/api/map-pins`, {...filters, isMobile: isMobile() })
            .then((res) => {
                if (!res || !res.data || !res.data.pins) return;

                dispatch(getMapPinsSuccess(res.data.pins || {}));
            }).catch((err) => {
                dispatch(getMapPinsFailure(err));
            })
    }
}

export function serverRedirect(pinId, action, type) {
    return (dispatch, getState) => {
        let config = {
            headers: {
                'Authorization': 'Bearer ' + getState().users.token
            }
        };
        // this call is only for the pop ups
        axios.get(connection().serverUrl + `/api/main/payment-redirect?pin_id=${pinId}&action=${action}&type=${type}`, config).then((res) => {
            // dispatch(loginTempSuccess(res));
            // browserHistory.push('/user-panel');
        }).catch((err)=> {
            // dispatch(loginTempFailure(err))
        })
    }
}

export const sendContactCall = (data) => {
    return (dispatch) => {
        dispatch(sendContact());
        // sending contact information
        axios.post(connection().serverUrl + "/api/main/contact", data)
        .then((response) => {
            dispatch(sendContactSuccess(response));

            const message = contactMessageWasSent();
            dispatch(openGeneralMessageModal(message.header, message.body));
        })
        .catch(err => {
            dispatch(closeContactModal());
            dispatch(sendContactFailure(err));
            const errMessage = generalErrorMsg();
            dispatch(openGeneralMessageModal(errMessage.header, errMessage.body));
        })
    }
};

export const submitPayment = (token, pin, files, type) => {
    return dispatch => {
        // const user = JSON.parse(localStorage.getItem('user'));
        if (type === 'free') {
            dispatch(savePin(token, pin, files));

            if (typeof localStorage !== 'undefined') {
                localStorage.removeItem('user');
            }

            return;
        }

        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        if (files && files.length > 0) {
            let formData = new FormData();
            files.forEach((file)=> {
                formData.append('images', file);
            });
            let fileconfig = {
                headers: { 'content-type': 'multipart/form-data' }
            };

            axios.post(connection().serverUrl + "/api/upload?d=" + (pin.id || pin._id), formData, fileconfig).then((res)=> {

                pin.images = res.data;
                dispatch(sendPayingReq(pin));
                axios.post(connection().serverUrl + "/api/main/enroll", { pin, files, type }, config).then((response) => {
                    dispatch(sendPayingSuccess(response));

                    dispatch(deleteWaitingLogin());

                    window.location.replace(response.data.url);

                }, (err) => {
                    dispatch(sendPayingFailure(err));
                })
            })
        } else {
            axios.post(connection().serverUrl + "/api/main/enroll", { pin, files, type }, config).then((response) => {
                dispatch(sendPayingSuccess(response));

                dispatch(deleteWaitingLogin());

                window.location.replace(response.data.url);

            }, (err) => {
                dispatch(sendPayingFailure(err));
            })
        }
    }
};

export const getSharedPin = pinId => {
    return (dispatch) => {
        if (!pinId || pinId.includes('#')) return Promise.resolve();

        dispatch(sendContact());
        // sending contact information
        return axios.get(connection().serverUrl + `/api/pin/${pinId}`).then(response => {
            dispatch(getSharedPinSuccess(response));

        }, err => dispatch(getSharedPinFailure(err)) );
    }
};

export const incPinViewCount = pinId => {
    return dispatch => {
        if (!pinId) return;

        // optimistic ui update
        dispatch(incPinViewCountRequest());

        axios.get(connection().serverUrl + `/api/pin/vc/${pinId}`).then(res => {
            dispatch(incPinViewCountSuccess(pinId));
        }, err => {
            // revert optimistic ui call
            dispatch(incPinViewCountFailure());
        });

    }
}



// WEBPACK FOOTER //
// ./src/Actions/main.js